/* eslint-disable @hakio/no-untranslated-terminology -- flag panel copy is internal (staff-only), not tenant-facing */
import { useState } from "react"

import { WorkspacePage } from "~/components/design-system/pages"
import { SearchInput, useFlagFilters } from "~/features/feature-flags/client/FlagControls"
import { FlagHistoryTable } from "~/features/feature-flags/client/FlagHistoryTable"
import { FlagPageWorkspace } from "~/features/feature-flags/client/flag-page/FlagPageWorkspace"
import type { FeatureFlagKey } from "~/features/feature-flags/shared/registry"

function AllFlagsHistory() {
  const { category, search, toolbar } = useFlagFilters({ placeholder: "Search flags or companies" })
  return (
    <WorkspacePage fillContent toolbar={toolbar}>
      <FlagHistoryTable category={category} search={search} />
    </WorkspacePage>
  )
}

function OneFlagHistory({ flagKey }: { flagKey: FeatureFlagKey }) {
  const [search, setSearch] = useState("")
  return (
    <FlagPageWorkspace
      toolbar={
        <SearchInput value={search} onChange={setSearch} placeholder="Search companies or users" />
      }
    >
      <FlagHistoryTable flagKey={flagKey} category="all" search={search} />
    </FlagPageWorkspace>
  )
}

/** Flag changes, newest first: every flag's on the overview, or one flag's on its page. */
export function HistoryTab({ flagKey }: { flagKey?: FeatureFlagKey }) {
  return flagKey ? <OneFlagHistory flagKey={flagKey} /> : <AllFlagsHistory />
}
